import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import blogApi from "../../utils/api/blogApi";
import { BlogResponseDto, LocalizationEnum } from "../../utils/types/blog";

export default function BlogIndividual() {
  const { id } = useParams<{ id: string }>();
  const [blog, setBlog] = useState<BlogResponseDto | null>(null);
  const [loading, setLoading] = useState(true);

  const formatDate = (dateString: string, lang: LocalizationEnum) => {
    const date = new Date(dateString);
    lang = 1; // Force MK for now

    const monthsMK = [
      "Јануари", "Февруари", "Март", "Април", "Мај", "Јуни",
      "Јули", "Август", "Септември", "Октомври", "Ноември", "Декември",
    ];

    const monthsRS = [
      "Јануар", "Фебруар", "Март", "Април", "Мај", "Јун",
      "Јул", "Август", "Септембар", "Октобар", "Новембар", "Децембар",
    ];

    const monthsEN = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December",
    ];

    const dictionary =
      lang === 1 ? monthsMK :
      lang === 2 ? monthsRS :
      monthsEN;

    return `${date.getDate()} ${dictionary[date.getMonth()]} ${date.getFullYear()}`;
  };

  useEffect(() => {
    const loadBlog = async () => {
      try {
        const { data } = await blogApi.get<BlogResponseDto>(`/blogs/${id}`);
        setBlog(data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    loadBlog();
  }, [id]);

  if (loading)
    return (
      <div className="text-center py-20 text-lg font-semibold text-gray-600">
        Loading...
      </div>
    );

  if (!blog)
    return (
      <div className="text-center py-20 text-lg font-semibold text-red-600">
        Blog not found.
      </div>
    );

  return (
      <div className="bg-white min-h-screen py-8 px-4">
          <div className="max-w-3xl mx-auto text-center">

              <h1 className="text-4xl font-bold text-gray-900 mb-4">
              {blog.title}
              </h1>

              <p className="text-lg text-gray-600 mb-8">
              {blog.excerpt}
              </p>

              {blog.mainImageUrl && (
              <img
                  src={blog.mainImageUrl}
                  alt={blog.title}
                  className="w-full shadow mb-10"
                  style={{ borderRadius: "16px" }}
              />
              )}

              <div
              className="prose prose-lg mx-auto text-left"
              dangerouslySetInnerHTML={{ __html: blog.content }}
              />
          </div>

          <div className="flex items-center justify-center my-12 text-gray-500 font-medium">
              <div className="flex-grow border-t border-gray-300"></div>
              
              <span className="mx-4">
                  {formatDate(blog.dateModified, blog.localization)}
              </span>
              
              <div className="flex-grow border-t border-gray-300"></div>
          </div>
      </div>
  );
}